import { action, computed, makeObservable, observable } from 'mobx';
import DownloadTask, { DownloadTaskParams } from './DownloadTask';

export default class AssetsZipDownloadTask extends DownloadTask {
	constructor( { id, messagingService, downloadInitializer }: DownloadTaskParams ) {
		super( { id, messagingService, downloadInitializer } );

		makeObservable( this, {
			title: computed,
			countText: computed,
			count: observable,
			total: observable,
			status: observable,
			errors: computed,
			progressPercent: computed,
			hasFinished: computed,
			observeDownloadFromBackend: action,
			cancel: action,
			onDownloadEventReceived: action
		} );
	}

	get title() {
		return 'Zipping Assets';
	}

	get countText() {
		if ( this.status === 'successful' ) return `Finished ${this.count}/${this.total}`;
		if ( this.status === 'failed' ) return 'Error Downloading';
		if ( this.status === 'canceled' ) return 'Canceled';

		return `Preparing ${this.count}/${this.total}`;
	}
}
